// src/admin/core/dataProvider.js

const getAuthToken = () => localStorage.getItem("jwtToken") || null;

/**
 * Creates a dataProvider for a specific API endpoint.
 * Example: createDataProvider("/admin_user_list")
 */
export const createDataProvider = (apiUrl) => ({
  getList: (resource, params) => {
    const token = getAuthToken();
    const { page, perPage } = params.pagination || { page: 1, perPage: 25 };
    const filters = params.filter || {};

    const queryParams = new URLSearchParams({
      page: String(page),
      perPage: String(perPage),
    });

    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        queryParams.append(key, value);
      }
    });

    return fetch(`${apiUrl}?${queryParams}`, {
      headers: {
        "Content-Type": "application/json",
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
    })
      .then(async (res) => {
        if (!res.ok) {
          const text = await res.text();
          throw new Error(`Network error: ${text}`);
        }
        return res.json();
      })
      .then((json) => {
        if (!json || json.error) throw new Error(json?.msg || "API error");
        const records = (json.data || []).map((r) => ({
          ...r,
          id: r.user_id ?? r.id,
        }));
        return { data: records, total: json.total ?? records.length };
      });
  },

  getOne: (resource, params) => {
    const token = getAuthToken();
    return fetch(`${apiUrl}/${params.id}`, {
      headers: {
        "Content-Type": "application/json",
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
    })
      .then((res) => res.json())
      .then((json) => {
        if (!json || json.error) throw new Error(json?.msg || "API error");
        return {
          data: { ...json.data, id: json.data.user_id ?? json.data.id },
        };
      });
  },

  getMany: (resource, params) => {
    const token = getAuthToken();
    return fetch(apiUrl, {
      headers: {
        "Content-Type": "application/json",
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
    })
      .then((res) => res.json())
      .then((json) => {
        if (!json || json.error) throw new Error(json?.msg || "API error");
        const all = (json.data || []).map((r) => ({
          ...r,
          id: r.user_id ?? r.id,
        }));
        const data = all.filter((r) => params.ids.includes(r.id));
        return { data };
      });
  },

  create: () => Promise.reject(new Error("Not implemented")),
  update: () => Promise.reject(new Error("Not implemented")),
  updateMany: () => Promise.resolve({ data: [] }),
  delete: () => Promise.reject(new Error("Not implemented")),
  deleteMany: () => Promise.resolve({ data: [] }),
});
